import APIKit from "../APIKit";

function getPlansAndMyPlans(payload) {
  return new Promise(async (resolve, reject) => {
    try {
      const token = window.localStorage.getItem("auth_token");
      if (token) {
        payload.append("auth_token", token);
      }
    } catch (e) {
    }
    
    APIKit.post("/plans_and_my_plans", payload)
      .then(async (response) => {
        try {
          resolve(response.data);
        } catch (e) {
          reject(e);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export const planService = {
  getPlansAndMyPlans
};
